import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'access-document',
  name: 'Access Document',
  category: 'access-integrations',
  description: 'Access Document management - upload, download, search, and manage documents',
  icon: 'FileText',
  color: 'orange',
  version: '1.0.0',

  defaults: {
    name: 'Access Document',
    color: '#f97316' // Orange color
  },

  comingSoon: false,
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
  tags: ['access', 'document', 'dms', 'file', 'upload', 'download', 'integration'],

  // Tool-capable configuration for AI Agent
  toolCapable: {
    enabled: true,
    name: 'access_document_management',
    description: 'Interact with Access Document system to upload, download, search, and manage documents in folders with metadata tagging',
    allowManualDescription: false,
    parameters: {
      action: {
        toolParamName: 'action',
        description: 'The operation to perform: downloadDocument, getDocument, listDocuments, listDocumentTypes, listFolders, listTags, updateDocument, or uploadDocument',
        required: true,
        type: 'string',
      },
      documentId: {
        toolParamName: 'documentId',
        description: 'The document ID for download, get, or update operations',
        required: false,
        type: 'string',
      },
      versionId: {
        toolParamName: 'versionId',
        description: 'Specific version ID to download (omit for latest version)',
        required: false,
        type: 'string',
      },
      folderId: {
        toolParamName: 'folderId',
        description: 'Folder ID for document listing or upload destination',
        required: false,
        type: 'string',
      },
      includeSubFolders: {
        toolParamName: 'includeSubFolders',
        description: 'Whether to include subfolders in document search (default: false)',
        required: false,
        type: 'boolean',
      },
      docTypeId: {
        toolParamName: 'docTypeId',
        description: 'Document type ID for filtering or assigning to uploaded documents',
        required: false,
        type: 'string',
      },
      contentSearchPhrase: {
        toolParamName: 'contentSearchPhrase',
        description: 'Search phrase for document content or title search',
        required: false,
        type: 'string',
      },
      title: {
        toolParamName: 'title',
        description: 'Document title for upload or update operations',
        required: false,
        type: 'string',
      },
      fileName: {
        toolParamName: 'fileName',
        description: 'File name with extension for upload operations',
        required: false,
        type: 'string',
      },
      fileContent: {
        toolParamName: 'fileContent',
        description: 'Base64-encoded file content for upload operations',
        required: false,
        type: 'string',
      },
      tagValues: {
        toolParamName: 'tagValues',
        description: 'JSON array of tag values for document metadata: [{"tagId": 1, "tagValue": "value"}]',
        required: false,
        type: 'string',
      },
    },
    outputMapping: {
      success: 'Whether the operation succeeded',
      action: 'The action that was performed',
      documentId: 'The document ID (for operations that return or create documents)',
      data: 'The response data (documents, folders, types, tags, or file content)',
      fileName: 'The file name (for download operations)',
      fileSize: 'The file size in bytes (for download/upload operations)',
    },
  },
};

export default definition;
